import { Paths } from '../../constants/paths';
import { getRootUrl } from '../../utils/urls';
export const buildCategoryUrl = item => {
  var _item$category;
  return `${Paths.SEARCH_RESULTS}?eco_PRODUCT_TYPE=${String(item.productType || 'APP')}&eco_CATEGORY=${encodeURIComponent((_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category[0])}`;
};
export const buildCollectionUrl = item => {
  return `${Paths.FEATURED_COLLECTION.replace(':collectionSlug', item.slug || '')}`;
};
export const buildListingUrl = slug => {
  if (!slug) return undefined;
  return `${getRootUrl()}${Paths.LISTING_DETAILS.replace(':listingSlug', slug)}`;
};
export const buildSearchUrl = (input, queryType = 'ELASTIC_SEARCH') => {
  const query = typeof input === 'string' ? input : input.term;
  const queryTypeValue = typeof input === 'string' ? queryType : String(input.queryType || queryType);
  return `${Paths.SEARCH_RESULTS}?eco_search=${encodeURIComponent(query)}&eco_queryType=${queryTypeValue}`;
};
export const navigateToSearchResults = (item, history) => {
  switch (item.resultType) {
    case 'QUERY':
      history.push(buildSearchUrl(item));
      break;
    case 'LISTING':
      {
        const url = buildListingUrl(item.slug);
        if (url) {
          window.location.assign(url);
        }
        break;
      }
    case 'CATEGORY':
      history.push(buildCategoryUrl(item));
      break;
    case 'COLLECTION':
      history.push(buildCollectionUrl(item));
      break;
    default:
      break;
  }
};